// <shopify-account> (native Shopify web component): the signed-in account sheet is entirely
// Shopify-rendered — the only slot the component exposes is `signed-out-avatar` — so there's no
// theme-level way to add a "Sign out" link to it via the light DOM. Its shadow root is OPEN
// (readable/writable from outside), which is how shopify-account-hover.js already reads its
// dialog geometry; this module goes one step further and appends one node into it.
//
// Whether to inject comes from `data-show-signout` (set server-side from Liquid, true only when
// `customer` is present AND the "Show sign out button" section setting is on) rather than from
// sniffing the shadow markup — Shopify's own signed-in/out branching inside the shadow root isn't
// a stable contract to detect against, and Liquid already knows both answers.
//
// The sheet's shortcuts list re-renders as its data loads, replacing children — so injection
// can't be a one-shot append. A MutationObserver keeps re-adding the item if it gets wiped, and
// the "already present" check keeps repeated firings a no-op.
const SIGNOUT_MARKER = 'account-signout';

function buildSignOutItem(logoutUrl) {
  const wrapper = document.createElement('div');
  wrapper.className = 'account__item-wrapper';
  wrapper.innerHTML = `<a href="${logoutUrl}" class="account__item" data-account-item="${SIGNOUT_MARKER}"><span class="account__item-text">Sign out</span></a>`;
  return wrapper;
}

function injectSignOut(host, logoutUrl) {
  const shortcuts =
    host.shadowRoot && host.shadowRoot.querySelector('.account__shortcuts');
  if (
    !shortcuts ||
    shortcuts.querySelector(`[data-account-item="${SIGNOUT_MARKER}"]`)
  )
    return;
  shortcuts.appendChild(buildSignOutItem(logoutUrl));
}

function initAccountSignOut(host) {
  if (host.dataset.showSignout !== 'true') return;
  const logoutUrl = host.dataset.logoutUrl || '/account/logout';
  if (!host.shadowRoot) return;

  injectSignOut(host, logoutUrl);
  new MutationObserver(() => injectSignOut(host, logoutUrl)).observe(
    host.shadowRoot,
    {
      childList: true,
      subtree: true,
    }
  );
}

export default function initShopifyAccountSignOut() {
  customElements.whenDefined('shopify-account').then(() => {
    document.querySelectorAll('shopify-account').forEach(initAccountSignOut);
  });
}

// Self-initialising side-effect import (matches the sibling modules in this folder).
initShopifyAccountSignOut();
